import React, { useEffect, useState } from 'react';
import '@/styles/main.scss';
// Global CSS importy pro knihovny
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';
import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'react-toastify/dist/ReactToastify.css';

import type { AppProps } from 'next/app';
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from 'react-query';
import { reportError } from '@/shared/services/analytics/errorTelemetry';
import { DefaultSeo } from 'next-seo';
import JsonLd from '@/features/marketing/seo/JsonLd';
import { organizationSchema } from '@/features/marketing/seo/schemas/organization';
import dynamic from 'next/dynamic';
import { reportTouch } from '@/shared/services/analytics/attribution';
import UtmNavigationPreserver from '@/shared/components/UtmNavigationPreserver';
import StaleBuildGuard from '@/shared/components/StaleBuildGuard';

const CookieConsent = dynamic(() => import('@/shared/components/CookieConsent'), { ssr: false });

function MyApp({ Component, pageProps } : AppProps) {
    const [queryClient] = useState(() => new QueryClient({
        defaultOptions: { queries: { refetchOnWindowFocus: false, retry: false } },
        queryCache: new QueryCache({ onError: (error) => reportError(error, { operation: 'query' }) }),
        mutationCache: new MutationCache({ onError: (error) => reportError(error, { operation: 'mutation' }) }),
    }));

    useEffect(() => {
        reportTouch();
    }, []);

    return <>
        <DefaultSeo
            openGraph={{
                type: 'website',
                locale: 'cs_CZ',
                url: 'https://bubotrans.cz/',
                siteName: 'BUBO trans',
                title: 'Bubotrans.cz - Specialista na přepravu Vašich zásilek',
                description: 'Specialista na přepravu dokumentů, balíků i palet po celém světě s výborným zákaznickým servisem.',
                images: [{ url: 'https://bubotrans.cz/shareimg.png' }],
            }}
        />
        <JsonLd id='org-schema' data={organizationSchema()} />
        {/* <Head>
            <meta name='viewport' content='width=device-width, initial-scale=1.0' />
            <meta property='og:url' content='https://bubotrans.cz/' key='og-url' />
            <meta property='og:title' content='Bubotrans.cz - Specialista na přepravu Vašich zásilek' key='og-title' />
            <meta property='og:description' content='Specialista na přepravu dokumentů, balíků i palet po celém světě s výborným zákaznickým servisem.' key='og-description' />
            <meta property='og:image' content='https://bubotrans.cz/shareimg.png' key='og-image' />
            <meta property='og:type' content='website' key='og-type' />

            <meta name='twitter:card' content='summary_large_image' key='twitter-image' />
            <meta property='twitter:domain' content='bubotrans.cz' key='twitter-domain' />
            <meta property='twitter:url' content='https://bubotrans.cz/' key='twitter-url' />
            <meta name='twitter:title' content='Bubotrans.cz - Specialista na přepravu Vašich zásilek' key='twitter-title' />
            <meta name='twitter:description' content='Specialista na přepravu dokumentů, balíků i palet po celém světě s výborným zákaznickým servisem.' key='twitter-description' />
            <meta name='twitter:image' content='https://bubotrans.cz/shareimg.png' key='twitter-image' />
        </Head> */}
        {/* Google Tag Manager načítá CookieConsent až po souhlasu. */}
        <CookieConsent />
        <UtmNavigationPreserver />
        <StaleBuildGuard />

        <QueryClientProvider client={queryClient}>
            <Component {...pageProps} />
        </QueryClientProvider>
    </>;
}

export default MyApp;
